import styles from './Subtitle.module.scss';

type SubtitleProps = {
    content: string
}

const Subtitle: React.FC<SubtitleProps> = ({ content }) => {
    return (
        <p className={styles.content}>{content}</p>
    );
}

export default Subtitle;
